module.exports = __webpack_public_path__ + "img/33_4.ba58205f.png";